const state = {
  modalName: ''
};

const actions = {
  setModalName({ commit }, name){
    commit('SET_MODAL_NAME', name);
  }
};

const mutations = {
  SET_MODAL_NAME(state, name){
    state.modalName = name;
  }
};

export default { namespaced: true, state: () => state, actions, mutations };